// React
import React, { Component } from "react";

// Routes
import { LoginRoutes } from '../../Routes';

// Styles
import '../../Views/Login/login.css';
import './footer.css';

// Utils
import { GoogleAnalytics, Validate } from '../../Utils';

/**********************************************************
 *    Subscription Component
 * 
 *  - Saves user's email and submits it
 * 
 **********************************************************/

class Subscription extends Component {

    /**********************************************************
     *  Constructor
     **********************************************************/

    constructor(props) {

        super(props);

        this.state = {
            email : '',
            buttonText : 'Subscribe',
            buttonClass : 'subscribe-button'
        }
    }

/**********************************************************
 *   Functions
 **********************************************************/

    // Changes the value of email and validates on each keystroke
    updateEmail = (event) => {

        var updatedEmail = event.target.value;

        this.setState((prevState,props) => {
            return {
                email : updatedEmail
            }
        });

    }


    // If user hits enter button on page,
    // treat as if they clicked subscription buton
    handleKeyPress = (target) => {

        if(target.charCode === 13) {
            this.subscribe();
        }
            
    }

    
    // Resets email, and saves button details as error
    saveErrorToState = () => {

        this.setState((prevState,props) => {
            return {
                email : '',
                buttonText : 'Hmm, Try Again',
                buttonClass : 'subscribe-button error'
            }
        });

    }


    // Validates and submits email address
    subscribe = () => {

        const emailErrors = Validate.email(this.state.email);

        if(emailErrors.length === 0) {

            GoogleAnalytics.newAction('Footer', 'Subscription');

            LoginRoutes.subscribe(this.state.email)
                .then( (success) => {
                    this.setState((prevState,props) => {
                        return {
                            email : '',
                            buttonText : 'Subscribed!',
                            buttonClass : 'subscribe-button saved'
                        }
                    });
                })
                .catch( (error) => {
                    this.saveErrorToState();
                });
        }
        else {
            this.saveErrorToState();
        }

    }


/**********************************************************
 *   Render
 **********************************************************/

    render() {

        return (
            <div className='social-details subscribe-box'>
                <div className="splash-input" >
                    <input placeholder="you@domain.com"
                    value={this.state.email} onChange={this.updateEmail} 
                    onKeyPress={this.handleKeyPress} ></input>
                    <i className="icon-paperplane text-size-xlarge"></i>
                </div>
                <div className={this.state.buttonClass} onClick={this.subscribe}>{ this.state.buttonText }</div>
            </div>
        );
    }

}

export default Subscription;



// WEBPACK FOOTER //
// ./src/Components/Footer/Subscription.js